// extracted by mini-css-extract-plugin
module.exports = {"registerProductConfirmationWrapper":"RegisterProductConfirmation_registerProductConfirmationWrapper__CpU3d"};